import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import NewsController from '../../apis/controller/news.controller';

import { images } from '../../assets/images';
import { dateFormat } from '../../Components/helper/date';
import { renderImage } from '../../Components/helper/image';
import { routes } from '../../routes';

function Events(props) {
    return (
        <>
            {props && props.item.length > 0 && <div className="shadowed_whitebox p-3 p-lg-4 news_recent_posts mb-4">
                <div className="sidebar_title">
                    Recent Posts
                    <hr />
                </div>
                {props.item.map((item, index) => (
                    <div key={index} className="recent_post_item d-flex">
                        <div className="img_area">
                            <Link to={`/newsdetail/${item.slug}`}>
                            <img src={renderImage(item.image, 'small')} className="img-fluid" alt="..." />
                            </Link>
                        </div>
                        <div className="info_area">
                            <h5 >
                                <Link to={`/newsdetail/${item.slug}`}>
                                    {item.title}
                                </Link>
                            </h5>
                            <div className="recent_post_date">
                                <i className="far fa-calendar-alt"></i>
                                <span>{dateFormat(item.created)}</span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>}
        </>
    );
}

export default Events;